// @flow
import { schema } from 'normalizr';

export const department = new schema.Entity('department');
export const departments = new schema.Array(department);

export const subdepartment = new schema.Entity('subdepartment')
export const subdepartments = new schema.Array(subdepartment)
